module.exports = __webpack_public_path__ + "static/media/amn-auditor-cv.2dce4da7.svg";